<template>
  <div>
    <date-filter ref="date" @apply="applyFilter"></date-filter>
    <string-filter ref="string" @apply="applyFilter"></string-filter>
    <number-filter ref="number" @apply="applyFilter"></number-filter>
    <list-filter ref="list" @apply="applyFilter"></list-filter>
  </div>
</template>

<script>
import DateFilter from "./date-filter";
import NumberFilter from "./number-filter";
import StringFilter from "./string-filter";
import ListFilter from "./list-filter";

export default {
  name: "column-filters-modal",

  components: {
    DateFilter,
    NumberFilter,
    StringFilter,
    ListFilter,
  },

  data() {
    return {
      filterName: "",
    };
  },

  methods: {
    open(params) {
      this.filterName = params.name;

      switch (params.type) {
        case "date":
          this.$refs.date.open(params.value);
          break;
        case "number":
          this.$refs.number.open(params.value);
          break;
        case "string":
          this.$refs.string.open(params.value);
          break;
        case "list":
          this.$refs.list.open(params.value, params.getList);
          break;
        default: {
          break;
        }
      }
    },

    applyFilter(value) {
      this.$emit("apply", {
        name: this.filterName,
        value,
      });
    },
  },
};
</script>
<style lang="scss" src="./style.scss"></style>
